import React, { PureComponent, Fragment } from 'react'
import {
  DialogContent,
  DialogActions,
  Button,
  Divider
} from '@material-ui/core'
import { Print as PrintIcon } from '@material-ui/icons'

import { BookingsSheet, PrintWindow } from 'components'

export class PrintBookingsSheetBase extends PureComponent {
  state = {
    isPrintWindow: false
  }

  openPrintWindow = () => this.setState({ isPrintWindow: true })

  renderPrintWindow = (bookings, returnBookings) => (
    <PrintWindow>
      <BookingsSheet bookings={bookings} />
      {Boolean(returnBookings.length) && <BookingsSheet returnBookings={returnBookings} variant='return' />}
    </PrintWindow>
  )

  render() {
    const { data: { bookings, returnBookings }, onClose } = this.props
    const { isPrintWindow } = this.state

    return (
      <Fragment>

        {isPrintWindow && this.renderPrintWindow(bookings, returnBookings)}

        <DialogActions>
          <Button color='secondary' onClick={onClose}>
            Скасувати
          </Button>
          <Button color='primary' onClick={this.openPrintWindow}>
            Роздрукувати
            <PrintIcon fontSize='small' style={{ marginLeft: 5 }} />
          </Button>
        </DialogActions>

        <Divider />

        <DialogContent>
          <BookingsSheet bookings={bookings} />
          {Boolean(returnBookings.length) && <BookingsSheet returnBookings={returnBookings} variant='return' />}
        </DialogContent>
        
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PrintBookingsSheet/PrintBookingsSheet.js